export type StoredManualTracking = {
  tracking_number?: string | null;
  shipping_provider?: string | null;
  service_name?: string | null;
};

/** Restore the stored representation: custom carriers persist an empty provider. */
export function restoreManualTrackingCarrier(stored?: StoredManualTracking | null): { code: string; custom: string } {
  const provider = (stored?.shipping_provider ?? "").trim().toLowerCase();
  if (["auspost", "australia post", "australia_post"].includes(provider)) {
    return { code: "auspost", custom: "" };
  }
  const name = stored?.service_name ?? "";
  if (name.trim()) return { code: "other", custom: name };
  if (provider) return { code: "other", custom: provider === "other" ? "" : (stored?.shipping_provider ?? "") };
  return { code: "", custom: "" };
}

/** Preserve unchanged legacy/blank representations without inventing a carrier. */
export function storedManualTrackingMatches(stored: StoredManualTracking | null | undefined,
  number: string, code: string, custom: string): boolean {
  if (!number.trim() || number.trim() !== (stored?.tracking_number ?? "").trim()) return false;
  const restored = restoreManualTrackingCarrier(stored);
  return code === restored.code && (code !== "other" || custom.trim() === restored.custom.trim());
}
